import { z } from 'zod';
import { REFERER_OPTION_VALUES } from '#screens/signup/form/referer-options.ts';

export const signupFormSchema = z.object({
  email: z
    .string()
    .min(1, 'What’s your email address?')
    .min(3, 'Email address must be at least 3 characters')
    .max(800, 'Whoa that’s a long email.  Sorry, but it needs to be 800 characters or fewer.'),
  referer: z.enum([...REFERER_OPTION_VALUES, '']),
});

export type SignupFormData = z.infer<typeof signupFormSchema>;
